import {
  LOADER_STATUS,
  SELECTED,
  SELECTED_ROW,
  TOTAL_PAGES_HISTORY,
  TOTAL_PAGES_UPLOAD,
  UPLOAD_HISTORY_TABLE_DATA,
  UPLOAD_TABLE_DATA,
} from "./constants";

export const initialState = {
  loaderStatus: false,
  uploadTableData: [],
  uploadHistoryTableData: [],
  selected: [],
  selectedRow: [],
  totalPagesHistory: 1,
  totalPagesUpload: 1,
};

/* eslint-disable default-case, no-param-reassign */
const imsRecoFetchReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case UPLOAD_TABLE_DATA:
      return {
        ...state,
        uploadTableData: action.uploadTableData,
      };
    case UPLOAD_HISTORY_TABLE_DATA:
      return {
        ...state,
        uploadHistoryTableData: action.uploadHistoryTableData,
      };
    case SELECTED:
      return {
        ...state,
        selected: action.selected,
      };
    case SELECTED_ROW:
      return {
        ...state,
        selectedRow: action.selectedRow,
      };
    case TOTAL_PAGES_HISTORY:
      return {
        ...state,
        totalPagesHistory: action.totalPagesHistory,
      };
    case TOTAL_PAGES_UPLOAD:
      return {
        ...state,
        totalPagesUpload: action.totalPagesUpload,
      };  
    default:
      return state;
  }
};

export default imsRecoFetchReducer;
